document.addEventListener('DOMContentLoaded', function() {
    // Find all tab block wrappers
    const tabBlocks = document.querySelectorAll('.tabs-block__wrapper');

    if (tabBlocks.length === 0) {
        return;
    }

    // Initialize each tab block independently
    tabBlocks.forEach(tabBlock => {
        const tabs = tabBlock.querySelectorAll('.tabs-block__tab');

        if (tabs.length === 0) {
            return;
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();

                // Get the block ID from the clicked tab
                const currentBlockId = tab.getAttribute('data-block-id');

                // Only affect tabs and panes within THIS specific block wrapper
                const currentBlockTabs = tabBlock.querySelectorAll('.tabs-block__tab');
                const currentBlockPanes = tabBlock.querySelectorAll('.tabs-block__pane');

                // Remove active class from tabs and panes in this block only
                currentBlockTabs.forEach(t => t.classList.remove('is-active'));
                currentBlockPanes.forEach(p => p.classList.remove('is-active'));

                // Add active class to clicked tab
                tab.classList.add('is-active');

                // Add active class to corresponding pane
                const paneId = tab.getAttribute('data-tab');
                const targetPane = tabBlock.querySelector(`#${paneId}`);

                if (targetPane) {
                    targetPane.classList.add('is-active');
                }
            });
        });
    });
});
